//CARDS

const manageCards = () => {
	//если нет карточек - выйти
	if (document.querySelectorAll('.block-info__item').length == 0) return;

	const main = document.querySelector('.inner');
	const pageTitle = main.querySelector('section');
	const aside = main.querySelector('.aside');
	let asideCards;
	if(aside) asideCards = aside.querySelectorAll('.block-info__item');
	const mediaQueryMin = window.matchMedia('(min-width: 768px)')
	const mediaQueryMax = window.matchMedia('(max-width: 767px)')

	//если страница - это колледжи/вузы/профессии/новости, то вернуть ее
	const getPageWithCards = () => {
		//if(main && (pageTitle.classList == 'vuzes' || pageTitle.classList == 'colleges' || (pageTitle.classList == 'professions')&& window.matchMedia('(min-width: 768px)').matches)) {
		if(main && (pageTitle.classList == 'vuzes' || pageTitle.classList == 'colleges' || pageTitle.classList == 'professions' || pageTitle.classList == 'news')) {
			return pageTitle;
		}
		return;
	}
	let page = getPageWithCards();

	//найти карточки
	const findCards = (elem) => {
		const cardsAll = elem.querySelectorAll('.block-info__item');	
		return cardsAll;
	}

	//станд.функция - раскрытие/закрытие карточки по клику на шапку карточки или стрелку
	function applyBlockInfo()
	{
		let cards;
		if(aside && asideCards.length> 0 ){
			cards = findCards(aside);
		} else {
			cards = findCards(document);
		} 

		if(cards) {

			cards.forEach((card) => {

				let cardHeader = card.children[0];
				let cardContent = card.children[1];
				let cardControl = card.children[card.children.length - 1];

				card.addEventListener('click', (e) => {
					
					if((card.closest('.ege-memo' ) || card.closest('.express-test')) && mediaQueryMin.matches) return; // на стр ЕГЭ-памятка участнику и Экспресс-тест  при >768px ничего не делать
					
					if (e.target === cardHeader || e.target === cardControl) {
						cardHeader.classList.toggle('show');
						if(cardContent) cardContent.classList.toggle('show');
						if(cardControl)	cardControl.classList.toggle('transform');
					}
				})
			})
		}
	}

	// раскрытие/закрытие карточки по клику в любом месте карточки (кроме ссылок, кнопок)
	const appleItemCard = () => {

		let arr = findCards(page);//для карточек вузов/колледжей/профессий(десктоп)
		arr.forEach(card => {
			let cardHeader = card.children[0];
			let cardContent = card.children[1];
			let cardControl = card.children[card.children.length - 1];
			card.addEventListener('click', (e) => {

				if ((e.target.tagName == 'A' || e.target.parentNode.tagName == 'A') || (e.target.tagName == 'BUTTON' || e.target.parentNode.tagName == 'BUTTON')){
					return;
				} else if(e.target.tagName == 'INPUT') {
					return;
				} else if(e.target.closest('.filter__item' ) && mediaQueryMax.matches) {
					return; //фильтры на стр. Профессии на мобильных
				} else {
					cardHeader.classList.toggle('show');
					if(cardContent) cardContent.classList.toggle('show');
					if(cardControl)	cardControl.classList.toggle('transform');
				}
			})
		})
	}

	//если другая страница или на бок.панели есть карточки
	//то применить станд.функцию для раскрытия/закрытия карточки
		
	if(!page || asideCards.length > 0) applyBlockInfo(); 
	if(page) appleItemCard();
}



export {manageCards}
